// File: config.notification.js
// Author: Brandon Shreve
// Date: 10/25/2018
// Desc: Configuration items for the notification component.
// Other Contributors:

export const notifications = {
    refreshTimer: 1,   // in minutes
};